import Input from '@taglivros/oef_componentes/build/components/input'
import Select from '@taglivros/oef_componentes/build/components/select'
import { formatDataNascimento, formatTelefone } from '../../utils/formatter/formatter'
import { validacaoDataNascimento, validacaoEmail, validacaoNome, validacaoTelefone } from '../../utils/validadores/validadores'
import { handleKeyPressNumber, handleKeyPressRemoveEspaco, handleKeyPressNumerosECaracteresEspeciais } from '../../utils/helpers/helpers'

export const LABEL_SENHA_ANTIGA = 'Senha antiga'

export const LABEL_SENHA_NOVA = 'Nova senha'

export const ID_INPUT_SENHA_ANTIGA = 'senha-antiga'

export const ID_INPUT_SENHA_NOVA = 'senha-nova'

export const MENSAGEM_ERRO_SENHA_TAMANHO = 'Tamanho mínimo de 6 caracteres'

export const REFERENCE_PRONOUNS = [
  { 'visualizacao': 'No feminino', 'value': 'F', 'codigo': 'F' },
  { 'visualizacao': 'No masculino', 'value': 'M', 'codigo': 'M' },
  { 'visualizacao': 'Com qualquer uma das opções', 'value': 'Q', 'codigo': 'Q' },
  { 'visualizacao': 'Com nenhuma das opções', 'value': 'N', 'codigo': 'N' }
]

export const camposDadosPessoais = {
  'dtNascimento': {
    'formatador': data => formatDataNascimento( data, '-', '/' ),
    'handleKeyPress': event => handleKeyPressNumber( event ),
    'label': 'Data de nascimento',
    'obrigatorio': false,
    'tipoInput': Input.TIPO_TEL,
    'validador': data => validacaoDataNascimento( data )
  },
  'email': {
    'handleKeyPress': event => handleKeyPressRemoveEspaco( event ),
    'label': 'E-mail',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_EMAIL,
    'validador': email => validacaoEmail( email )
  },
  'nome': {
    'handleKeyPress': event => handleKeyPressNumerosECaracteresEspeciais( event ),
    'label': 'Nome',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_TEXTO,
    'validador': nome => validacaoNome( nome )
  },
  'sobrenome': {
    'handleKeyPress': event => handleKeyPressNumerosECaracteresEspeciais( event ),
    'label': 'Sobrenome',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_TEXTO,
    'validador': sobrenome => validacaoNome( sobrenome )
  },
  'sexo': {
    'label': 'Como podemos nos referir a você',
    'obrigatorio': false,
    'tipoInput': Select,
    'itens': REFERENCE_PRONOUNS
  },
  'telefone': {
    'formatador': telefone => formatTelefone( telefone ),
    'handleKeyPress': event => handleKeyPressNumber( event ),
    'label': 'Telefone',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_TEL,
    'validador': telefone => validacaoTelefone( telefone )
  }
}
